import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import CustodyExchangesPage from './CustodyExchangesPage';
import NonCustodyExchangesPage from './NonCustodyExchangesPage';

const ExchangesPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Операции
      </Typography>

      <Routes>
        <Route path="/" element={<Navigate to="/exchanges/custody" replace />} />
        <Route path="/custody" element={<CustodyExchangesPage />} />
        <Route path="/non-custody" element={<NonCustodyExchangesPage />} />
      </Routes>
    </Box>
  );
};

export default ExchangesPage;
